import { useTheme, type ThemePreference } from '../contexts/ThemeContext';

const OPTIONS: { value: ThemePreference; label: string; title: string }[] = [
  { value: 'light', label: 'Light', title: 'Light theme' },
  { value: 'dark', label: 'Dark', title: 'Dark theme' },
  { value: 'system', label: 'Auto', title: 'Match system preference' },
];

type ThemeToggleProps = {
  /** Compact variant for the login page */
  compact?: boolean;
};

export default function ThemeToggle({ compact = false }: ThemeToggleProps) {
  const { preference, setPreference } = useTheme();

  return (
    <div
      className={compact ? 'theme-toggle theme-toggle-compact' : 'theme-toggle'}
      role="group"
      aria-label="Theme"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`theme-toggle-btn${preference === opt.value ? ' is-active' : ''}`}
          onClick={() => setPreference(opt.value)}
          title={opt.title}
          aria-pressed={preference === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
